/**
 * Checks if an array contains any items.
 * @param {Array} arr The array to check.
 * @returns True, if the array contains items. Otherwise, false.
 * @obsolete Use isNullOrEmptyArray instead
 */
export const isNonEmptyArray = (arr) => !isNullOrEmptyArray(arr)

/**
 * Checks whether an object is both an array and is empty.
 * @param arr {any}
 * @return {boolean} true if not an array or empty. Otherwise, false.
 */
export const isNullOrEmptyArray = (arr) =>
  !arr || !Array.isArray(arr) || arr.length === 0

/**
 * Checks whether all elements within the given array are of a certain type e.g. typeof === 'string'
 * @param arr
 * @param type {string}
 * @return {boolean} true if all elements are of type. False if not array or not all elements are of same type
 */
export const isArrayOfType = (arr, type) => {
  return (
    arr &&
    Array.isArray(arr) &&
    arr.length &&
    // eslint-disable-next-line valid-typeof
    arr.every((i) => typeof i === type)
  )
}

/**
 * Insert an element into an array after a specific index.
 * @param {Array} array - The array to modify.
 * @param {number} index - The index after which to insert the element.
 * @param {*} element - The element to insert.
 * @returns {Array} The modified array.
 */
export function insertAfter(array, index, element) {
  array.splice(index + 1, 0, element)
  return array
}
